var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { styled } from 'styled-components';
import { useParams } from 'react-router-dom';
import { useDetailedAssignment } from '../../hooks/useDetailedAssignment';
import { useLazyAssignmentUpdate } from '../../hooks/useLazyUpdateAssignment';
import { NameField } from './components/NameField';
import { DateField } from './components/DateField';
import { isAssignmentStarted, isAssignmentCompleted, } from '../../constants/statuses';
import { StudentsTable } from './components/StudentsTable';
import { AssignmentDetailsPreloader } from './components/Preloader';
import { AssignmentErrorBoundary, isAssignmentError, } from '../../components/ErrorBoundary';
import { useAppGoogleAnalytics } from '../../../../../shared_app/hooks/useAppGoogleAnalytics';
import { ASSIGNMENTS_EVENTS, ASSIGNMENTS_EVENT_CATEGORIES, } from '../../constants/analytics';
import { parseISO } from 'date-fns';
var Wrapper = styled.div.withConfig({ displayName: "Wrapper", componentId: "sc-ciixg7" })(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var ScHeader = styled.div.withConfig({ displayName: "ScHeader", componentId: "sc-122esav" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-bottom: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px 0;\n"], ["\n  margin-bottom: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px 0;\n"])));
var AssignmentDetails = function (_a) {
    var groupId = _a.groupId;
    var assignmentId = useParams().assignmentId;
    var assignment = useDetailedAssignment(groupId, Number(assignmentId)).response;
    var _b = useLazyAssignmentUpdate(groupId), updateAssignment = _b[0], error = _b[1].error;
    var _c = useState(assignment), currentAssignment = _c[0], setCurrentAssignment = _c[1];
    var ga = useAppGoogleAnalytics();
    var handleNameEditClick = React.useCallback(function () {
        ga === null || ga === void 0 ? void 0 : ga.sendEventAsTeacher({
            category: ASSIGNMENTS_EVENT_CATEGORIES.assignmentDetailsPage,
            action: ASSIGNMENTS_EVENTS.assign_report_page_rename_click,
        });
    }, [ga]);
    var handleDateEditClick = React.useCallback(function () {
        ga === null || ga === void 0 ? void 0 : ga.sendEventAsTeacher({
            category: ASSIGNMENTS_EVENT_CATEGORIES.assignmentDetailsPage,
            action: ASSIGNMENTS_EVENTS.assign_report_page_calendar_click,
        });
    }, [ga]);
    var onNameSave = useCallback(function (updatedName) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!assignmentId)
                        return [2 /*return*/];
                    return [4 /*yield*/, updateAssignment(Number(assignmentId), {
                            name: updatedName,
                        })];
                case 1:
                    response = _a.sent();
                    if (response) {
                        setCurrentAssignment(response.data);
                    }
                    return [2 /*return*/];
            }
        });
    }); }, [assignmentId, updateAssignment]);
    var onDateSave = useCallback(function (updatedDate) { return __awaiter(void 0, void 0, void 0, function () {
        var data, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!assignment || !assignmentId)
                        return [2 /*return*/];
                    data = {
                        dates: Array.isArray(updatedDate)
                            ? updatedDate
                            : [parseISO(assignment.startDate), updatedDate],
                    };
                    if (!assignmentId)
                        return [2 /*return*/];
                    return [4 /*yield*/, updateAssignment(Number(assignmentId), data)];
                case 1:
                    response = _a.sent();
                    if (response && !isAssignmentError(response)) {
                        setCurrentAssignment(response.data);
                    }
                    return [2 /*return*/];
            }
        });
    }); }, [assignment, assignmentId, updateAssignment]);
    var editable = Boolean(currentAssignment && !isAssignmentCompleted(currentAssignment.status));
    var freezeStartDate = Boolean(editable &&
        currentAssignment &&
        isAssignmentStarted(currentAssignment.status));
    var skillsString = useMemo(function () { return currentAssignment === null || currentAssignment === void 0 ? void 0 : currentAssignment.skills.join('; '); }, [currentAssignment]);
    useEffect(function () {
        if (assignment) {
            var updatedStudents = assignment.students.map(function (student) { return (__assign(__assign({}, student), { statusItems: student.cards.map(function (card) {
                    return ({
                        status: card.status,
                        intervention: card.interventionMark,
                    });
                }) })); });
            setCurrentAssignment(__assign(__assign({}, assignment), { students: updatedStudents }));
        }
    }, [assignment]);
    if (!currentAssignment)
        return _jsx(AssignmentDetailsPreloader, {}, void 0);
    return (_jsx(AssignmentErrorBoundary, __assign({ error: error }, { children: _jsxs(Wrapper, __assign({ "data-testid": 'assignment-details' }, { children: [_jsxs(ScHeader, { children: [_jsx(NameField, { editable: editable, name: currentAssignment.name, onSubmit: onNameSave, onEdit: handleNameEditClick }, void 0), _jsxs("div", { children: ["Practice time: " + currentAssignment.duration + " min", skillsString ? " | Skills: " + skillsString : null] }, void 0), _jsx(DateField, { startDate: parseISO(currentAssignment.startDate), endDate: parseISO(currentAssignment.endDate), onSubmit: onDateSave, freezeStartDate: freezeStartDate, editable: editable, onEdit: handleDateEditClick }, void 0)] }, void 0), _jsx(StudentsTable, { groupId: groupId, assignment: currentAssignment }, void 0)] }), void 0) }), void 0));
};
export { AssignmentDetails };
var templateObject_1, templateObject_2;
